export default __webpack_public_path__ + "static/media/githubBlack.331473eb.svg";